module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAF9JREFUKFPNzbEJgEAQRNGp1QYswGD7NDIXzOTuQP0G4sHuWoDz0wcjhIzUZDIhpAc0Sq8+ZHQA5h4YYKcNDiw93pviwNp7ZziwhRLYQwnUUAJHKIE8+xtoXKHmwXcI3SlFmG99mF6sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/application-x-executable.png
// module id = BTai
// module chunks = 1